import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleJdModelState } from '../../store/slices/candidateManagementSlice';
import { X } from 'lucide-react';

function JobDescriptionModal() {
  const jobDescription = useSelector(
    (state) => state.candidateManagementSlice.selectedJobDescription,
  );
  const dispatch = useDispatch();

  console.log({ jobDescription });
  const createJobDataObject = (jobId, jobData) => {
    const baseObject = {
      jd_id: jobId,
      job_role: jobData.job_role,
      jobrole: jobData.job_role,
      jd_status: jobData.jd_status,
      posting_date: jobData.posting_date,
      experience_required: jobData.experience_required,
      job_description_type: jobData.job_description_type,
    };

    // Add skill-based data if available
    if (jobData.Required_Skills?.skill_based) {
      const skillBasedData = jobData.Required_Skills.skill_based || [];
      baseObject.required_skills = skillBasedData.map((skill) => ({
        skill_name: skill.skill_name,
        topics: skill.topics || [],
      }));
    } else {
      // Handle legacy/QuickRole Builder JDs
      const experience = (jobData.minExp + jobData.maxExp) / 2;
      baseObject.required_skills =
        experience < 4
          ? jobData.Required_Skills?.Medium || []
          : jobData.Required_Skills?.Hard || [];

      baseObject.optional_skills =
        experience < 4
          ? jobData.Required_Skills?.Easy || []
          : jobData.Required_Skills?.Medium || [];
    }

    // Add other fields
    if (jobData.Roles_and_Responsibilities?.length) {
      baseObject.roles_and_responsibilities =
        jobData.Roles_and_Responsibilities;
    }

    if (jobData.Tools_and_Technologies?.length) {
      baseObject.tools_and_technologies = jobData.Tools_and_Technologies;
    }

    if (jobData.GoodtoHave?.length) {
      baseObject.good_to_have = jobData.GoodtoHave;
    }

    return baseObject;
  };

  const jobRoleData = createJobDataObject(jobDescription?.id, jobDescription);
  const modalJobTitle =
    jobRoleData?.jobrole || jobRoleData?.job_role || 'Job Description';
  const modalExperience =
    jobDescription?.description?.minExp != null &&
    jobDescription?.description?.maxExp != null
      ? `${jobDescription?.description?.minExp} - ${jobDescription?.description?.maxExp} yrs`
      : jobRoleData?.experience_required || '';

  // Format job description for display
  const formatJobDescription = (jobRole, data) => {
    console.log({ data });
    const style = data?.selectedStyle || jobDescription?.questionType;

    if (
      style === 'screening' ||
      style === 'Initial Screening' ||
      style === 'Bring Your Own Questions'
    ) {
      return (
        <pre className="font-sans dark:glass-effect bg-bgSecondary text-md whitespace-pre-wrap break-words p-6 rounded-2xl shadow-inner dark:text-white text-textPrimary">
          {`${
            data?.Raw_Job_Description ||
            data?.description?.Raw_Job_Description ||
            data?.job_description ||
            '- None'
          }\n\n`}
        </pre>
      );
    }
    if (
      data?.selectedStyle === 'screening' ||
      data?.selectedStyle === 'Initial Screening' ||
      data?.selectedStyle === 'Bring Your Own Questions'
    ) {
      return (
        <pre className="font-sans dark:glass-effect bg-bgSecondary text-md whitespace-pre-wrap break-words p-6 rounded-2xl shadow-inner dark:text-white text-textPrimary">
          {`Job Description:\n${data.Raw_Job_Description || data.description.Raw_Job_Description || data.job_description || '- None'}\n\n`}
        </pre>
      );
    }
    if (
      jobDescription?.jobDescriptionType === 'customized' //For V2
    ){
      return(
        <pre className="font-sans dark:glass-effect bg-bgSecondary text-md whitespace-pre-wrap break-words p-6 rounded-2xl shadow-inner dark:text-white text-textPrimary">
          {`Job Description:\n${jobDescription?.jobDescription || '- None'}\n\n`}
        </pre>
      );
    }
    if (data.Required_Skills?.skill_based) {
      const skillBasedData = data.Required_Skills?.skill_based || [];
      const skillsDisplay = skillBasedData
        .map((skill) => {
          const topics =
            skill.topics && skill.topics.length > 0
              ? ` (${skill.topics.join(', ')})`
              : '';
          return `• ${skill.skill_name}${topics}`;
        })
        .join('\n');

      return (
        <pre className="font-sans dark:glass-effect text-md whitespace-pre-wrap break-words p-6 rounded-2xl shadow-inner dark:!text-white !text-textPrimary">
          {`Required Skills:\n${skillsDisplay || '- None'}\n\n${
            data.Roles_and_Responsibilities?.length
              ? `Roles & Responsibilities:\n${data.Roles_and_Responsibilities.map(
                  (item, i) => `${i + 1}. ${item}`,
                ).join('\n')}`
              : ''
          }\n\n${
            data.Tools_and_Technologies?.length
              ? `Tools & Technologies:\n  ${data.Tools_and_Technologies.join(
                  ', ',
                )}\n\n`
              : ''
          }${
            data.GoodtoHave?.length
              ? `Good to Have:\n  ${data.GoodtoHave.join(', ')}\n\n`
              : ''
          }`}
        </pre>
      );
    } else {
      const experience = (data.minExp + data.maxExp) / 2;
      return (
        <pre className="font-sans dark:glass-effect text-md whitespace-pre-wrap break-words p-6 rounded-2xl shadow-inner dark:!text-white !text-textPrimary">
          {`Required Skills:\n${
            experience < 4
              ? data.Required_Skills?.Medium?.length
                ? data.Required_Skills.Medium.map(
                    (skill, i) => `${i + 1}. ${skill}`,
                  ).join('\n')
                : '- None'
              : data.Required_Skills?.Hard?.length
                ? data.Required_Skills.Hard.map(
                    (skill, i) => `${i + 1}. ${skill}`,
                  ).join('\n')
                : '- None'
          }\n\nOptional Skills:\n${
            experience < 4
              ? data.Required_Skills?.Easy?.join(', ') || 'None'
              : data.Required_Skills?.Medium?.join(', ') || 'None'
          }\n\n${
            data.Roles_and_Responsibilities?.length
              ? `Roles & Responsibilities:\n${data.Roles_and_Responsibilities.map(
                  (item, i) => `${i + 1}. ${item}`,
                ).join('\n')}`
              : ''
          }\n\n${
            data.Tools_and_Technologies?.length
              ? `Tools & Technologies:\n  ${data.Tools_and_Technologies.join(
                  ', ',
                )}\n\n`
              : ''
          }${
            data.GoodtoHave?.length
              ? `Good to Have:\n  ${data.GoodtoHave.join(', ')}\n\n`
              : ''
          }`}
        </pre>
      );
    }
  };

  const handleCloseJDModel = () => {
    dispatch(toggleJdModelState());
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-opacity-5 backdrop-blur-xl z-[700] p-4">
      <div
        // ref={jdRef}
        className="flex flex-col dark:glass-effect rounded-lg shadow-lg backdrop-blur-[500px] w-full max-w-5xl h-[80vh] relative"
      >
        {/* Fixed Header */}
        <div className="flex justify-between items-start p-6 pb-4 gap-4 flex-shrink-0">
          <div className="flex flex-col">
            <span className="text-lg font-semibold text-textPrimary dark:text-white mt-1">
              Job Role : {jobDescription?.jobrole}
            </span>
            <h2 className="text-sm font-medium text-textPrimary dark:text-white mt-1">
              {modalJobTitle}
            </h2>
            {modalExperience && (
              <span className="text-sm text-textSecondary dark:text-gray-400">
                {modalExperience}
              </span>
            )}
          </div>
          <button
            onClick={handleCloseJDModel}
            className="hover:text-opacity-80 dark:text-white text-textPrimary"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        {/* Scrollable Content */}
        <div className="px-6 pb-6 space-y-6 overflow-y-auto overflow-x-hidden flex-1">
          {jobDescription && (
            <div>
              {formatJobDescription(
                jobDescription?.jobrole || jobDescription?.job_role,
                jobDescription?.description,
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default JobDescriptionModal;
